import {Box, Typography} from '@mui/material';
import ArrButton from '../../../../../common/arr-button/ArrButton';
import {t} from 'i18next';
import './NewJobDetailHeader.scss';
import ExitJobModal from '../exit-job-modal/ExitJobModal';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../../../redux/store';

interface NewJobDetailHeaderProps {
  showExitModal: boolean;
  setShowExitModal: (open: boolean) => void;
}
const NewJobDetailHeader = ({
  showExitModal,
  setShowExitModal,
}: NewJobDetailHeaderProps) => {
  const handleExitJobCreation = () => {
    setShowExitModal(true);
  };

  const cloneJobName = useSelector(
    (state: RootState) => state.aiReview.cloneJobName
  );

  const handleCloseModal = () => {
    setShowExitModal(false);
  };

  return (
    <Box className="new-job-detail-header-container">
      {cloneJobName ? (
        <Typography
          className="clone-job-header-title typo-text headline3_size"
          tabIndex={0}
          data-testid={`clone-job-new-job-detail-header`}
        >
          {cloneJobName}
          <span className="clone-job-suffix">
            {' '}
            {t('ai.review.newJobDetail.cloneHeaderSuffix')}
          </span>
        </Typography>
      ) : (
        <Typography
          className="header-title"
          tabIndex={0}
          data-testid={`new-job-detail-header-header`}
        >
          {' '}
          {t('ai.review.newJobDetail.header')}
        </Typography>
      )}

      <ArrButton
        variant="secondary"
        size="medium"
        disabled={false}
        aria-label={t('ai.review.newJobDetail.exitJob')}
        dataTestId="exit-job-button"
        className="exit-job-button"
        onClick={handleExitJobCreation}
      >
        {t('ai.review.newJobDetail.exitJob')}
      </ArrButton>
      <ExitJobModal open={showExitModal} onClose={handleCloseModal} />
    </Box>
  );
};

export default NewJobDetailHeader;
